import { BASE_URL, DEV_BASE_URL, SORT_BY } from "./constants";

export const sortData = (dataToSort, sortBy, sortKey) => {
	if (!dataToSort && !dataToSort.length) {
		return [];
	}

	switch (sortBy) {
		case SORT_BY.ASCENDING:
			dataToSort.sort((a, b) => {
				const nameA = a[sortKey].toUpperCase();
				const nameB = b[sortKey].toUpperCase();

				if (nameA < nameB) {
					return -1;
				}

				if (nameA > nameB) {
					return 1;
				}

				return 0;
			});
			break;
		case SORT_BY.DESCENDING:
			dataToSort.sort((a, b) => {
				const nameA = a[sortKey].toUpperCase();
				const nameB = b[sortKey].toUpperCase();

				if (nameA < nameB) {
					return 1;
				}

				if (nameA > nameB) {
					return -1;
				}

				return 0;
			});
			break;
		default:
			break;
	}

	return dataToSort;
};

export const getBaseUrl = () => {
	let baseUrl = DEV_BASE_URL;

	if (window.location.href.includes("localhost")) {
		baseUrl = DEV_BASE_URL;
	} else {
		baseUrl = BASE_URL;
	}

	return baseUrl;
};
